import { useNavigationContext } from '3-foundation/Navigation/NavigationContext';
import { PageContext } from '3-foundation/PageContent/PageContext';
import { useContext } from 'react';
import { UI_LocalNavigation } from 'ui/components/2-molecules/Navigation/LocalNavigation/LocalNavigation';

export const LocalNavigation = ({
	heading,
	additionalNavigationItems,
}: { heading?: string; additionalNavigationItems?: Navigation.NavigationItem[] } = {}) => {
	const navContext = useNavigationContext();
	const pageContext = useContext(PageContext);

	const localNavigation = navContext?.getLocalNavigation({
		byId: pageContext.id,
		currentUrl: pageContext.url,
	});

	const localNavigationItems = [...(localNavigation?.descendants ?? []), ...(additionalNavigationItems ?? [])];
	if (localNavigationItems.length < 1) return null;

	return <UI_LocalNavigation heading={heading || localNavigation?.title || localNavigation?.name} localNavigationItems={localNavigationItems} />;
};
